import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-695ba808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-row-box" }
const _hoisted_2 = { style: {"display":"flex"} }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        title: _withCtx(() => [
          _createVNode(_component_ui_title, { title: "发货仓库" }, {
            right: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.operat()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新建仓库")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            class: "search-box",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_form_item, { label: "仓库名称" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _ctx.condition.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.condition.name) = $event)),
                      placeholder: "请输入仓库名称",
                      style: {"width":"200px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "仓库类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.condition.isDefault,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.condition.isDefault) = $event)),
                      clearable: "",
                      placeholder: "全部",
                      style: {"width":"200px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "默认仓库",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "非默认仓库",
                          value: "0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: "",
                style: {"margin-bottom":"0"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.find())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("筛选")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      style: {"margin":"0 0 0 10px"},
                      onClick: _ctx.resetFilter,
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置筛选条件")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createBlock(_component_ui_table, {
            data: _ctx.source.list
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "仓库名称",
                "min-width": "140"
              }),
              _createVNode(_component_el_table_column, {
                label: "仓库类型",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  (row.isDefault)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "默认仓库"))
                    : (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        type: "primary",
                        onClick: ($event: any) => (_ctx.setDefault(row)),
                        underline: false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("设为默认")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "senderName",
                label: "发货人",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.senderName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "senderMobile",
                label: "发货人手机号",
                width: "140"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.senderMobile || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "发货地址",
                "min-width": "240"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.fullAddress(row)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "160",
                align: "right"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    icon: "Edit",
                    type: "primary",
                    onClick: ($event: any) => (_ctx.operat(row.id))
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_el_popconfirm, {
                    onConfirm: ($event: any) => (_ctx.delRow(row.id)),
                    title: "是否删除该仓库？"
                  }, {
                    reference: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "danger",
                        icon: "Delete",
                        style: {"margin-left":"10px"}
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _ctx.source.loading]
          ]),
          _createVNode(_component_ui_page, {
            modelValue: _ctx.page.page,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page.page) = $event)),
            info: _ctx.pageInfo
          }, null, 8, ["modelValue", "info"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}